<template>
    <modal
        :title="title | trans"
        @close="$emit('close')">
        <template>
            <div v-for="n in notes" class="bg-darkGreen-200 shadow rounded-lg p-3 text-left font-normal text-white mb-3">
                <div class="font-bold">{{ n.mentor }}</div>
                <div class="text-xs italic">{{ new Date(n.timestamp._seconds * 1000) | sessionDate }}</div>
                <p>{{ n.note }}</p>
            </div>

            <template v-if="isLoggedIn && can_add_notes">
                <loader v-if="loading" class="m-auto"/>
                <template v-else>
                    <textarea v-model="note"
                              rows="2"
                              class="w-full py-1 sm:py-2 md:p-3 mb-4 border bg-light-200 border-light-300 rounded-lg focus:outline-none text-muted-500 font-bold focus:bg-transparent focus:border-lightGrey-200"
                    ></textarea>

                    <div v-if="errorMessage" class="w-full px-4 py-3 bg-risk-400 rounded-full text-center text-light-100 mb-4">
                        {{ errorMessage }}
                    </div>

                    <button @click="save()"
                            type="button"
                            class="py-2 px-4 bg-darkGreen-200 hover:bg-darkGreen-100 text-white font-bold rounded-lg">Add New Note</button>
                </template>
            </template>

            <div v-if="!isLoggedIn">
                Only mentors can add notes. If you are a mentor please <a :href="'authenticate?return=' + returnUrl" class="text-darkGreen-200 hover:text-darkGreen-100">log in</a>
            </div>

            <div v-if="isLoggedIn && !can_add_notes">Only mentors can add notes.</div>
        </template>
    </modal>
</template>

<script>
    import Modal from './Modal';
    import Loader from '../shared/Loader';
    import { addNoteToScoreCompetency } from '../../questions/notes';

    export default {
        components: {
            Modal,
            Loader
        },

        props: {
            notes: Array,
            shareToken: String,
            questionnaire: String,
            session: String,
            competency: Object,
            can_add_notes: Boolean,
            isLoggedIn: Boolean,
            returnUrl: String
        },

        data() {
            return {
                loading: false,
                note: null,
                errorMessage: null,
            };
        },

        computed: {
            title() {
                return {
                    'en': 'Notes',
                    'es': 'Notas',
                };
            },
        },

        methods: {
            save() {
                this.loading = true;

                addNoteToScoreCompetency(
                    this.shareToken,
                    this.questionnaire,
                    this.session,
                    this.competency.id,
                    this.note
                ).then(({data}) => {
                    if (data.error) {
                        this.errorMessage = data.error;
                    }

                    this.notes.push(data.note);
                    this.note = null;
                    this.errorMessage = null;
                    this.loading = false;
                });
            }
        },
    }
</script>
